const isVisible = (el) => {
    return !!el && !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
};

export default isVisible;
